import { Alert, Card, Stack } from '@mui/material'
import type { CanonicalPeriod, EmissionTier } from '../common'
import WaterRiskOverview from './waterRisk/WaterRiskOverview'

type PropertyWaterRiskProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
}

const PropertyWaterRisk = ({ propertyId, emissionTier, selectedPeriod }: PropertyWaterRiskProps) => {
  if (!propertyId) {
    return <Alert severity="info">Select a property to view water risk metrics.</Alert>
  }

  return (
    <Stack spacing={4}>
      <Card sx={{ p: 3 }}>
        <WaterRiskOverview propertyId={propertyId} emissionTier={emissionTier} selectedPeriod={selectedPeriod} />
      </Card>
    </Stack>
  )
}

export default PropertyWaterRisk
